import { ArrowRight } from 'lucide-react';
import { forwardRef } from 'react';

import { Button } from '@/shared/components/ui/button';

export const PlaceholderButton = forwardRef<
  HTMLButtonElement,
  { action?: () => void } & React.ComponentPropsWithoutRef<typeof Button>
>(({ action, ...props }, ref) => {
  return (
    <Button
      variant={'greenGradient'}
      doubleBorderConfig={{}}
      shape={'circle'}
      className="p-0"
      onClick={action}
      ref={ref}
      {...props}
    >
      <ArrowRight size={28} />
    </Button>
  );
});
